import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityMonitoredObjects } from '@api/data-security/getDataSecurityMonitoredObjects';

export const getCoreDataSecurityMonitoredObjectsSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityMonitoredObjects',
	receive: true,
	request: true,
	requestHandler: getDataSecurityMonitoredObjects,
	retainDataOnRequest: true
});
